module.exports = __webpack_public_path__ + "img/goodThing.5bbe548d.png";